import React, { ReactNode } from 'react'
import { AnyObject } from 'react-final-form'

import { IS_WEB } from '../../constants'

/**
 * For desktop usage of react-final-form, we need the ability to auto submit when
 * pressing the enter key.
 * https://github.com/final-form/react-final-form/issues/613#issuecomment-623663315
 * */
export const FormContainer = ({
  handleSubmit,
  children,
  style,
}: {
  handleSubmit: (
    event?: Partial<Pick<React.SyntheticEvent, 'preventDefault' | 'stopPropagation'>>,
  ) => Promise<AnyObject | undefined> | undefined
  children: ReactNode
  style?: React.CSSProperties
}): JSX.Element => {
  return IS_WEB ? (
    <form onSubmit={handleSubmit} style={{ ...style, display: 'contents' }}>
      {children}
    </form>
  ) : (
    <>{children}</>
  )
}
